/**
 * External Dependencies
 */
import { __ } from '@wordpress/i18n';
import { addFilter } from '@wordpress/hooks';
import classnames from 'classnames';

import dt_responsive from './common';

/**
 * Add custom element class in save element.
 *
 * @param {Object} extraProps     Block element.
 * @param {Object} blockType      Blocks object.
 * @param {Object} attributes     Blocks attributes.
 *
 * @return {Object} extraProps Modified block element.
 */
function applyExtraClass( extraProps, blockType, attributes ) {

    const { maskImgTop, maskImgBottom, responsiveSelector, responsiveCss } = attributes;

	if ( typeof maskImgTop !== 'undefined' && maskImgTop != '' ) {
		// remove previous class if it exists
	    var cleanClassTop = extraProps.className.replace(/dt-gb-filters-mask__top[^"|'|\s]*/gmi, '');
		// add new class
		extraProps.className = classnames( cleanClassTop, 'dt-gb-filters-mask__top--' + maskImgTop.replace(/^m-/, '') );
	}

	if ( typeof maskImgBottom !== 'undefined' && maskImgBottom != '' ) {
		// remove previous class if it exists
		var cleanClassBottom = extraProps.className.replace(/dt-gb-filters-mask__bottom[^"|'|\s]*/gmi, '');
		// add new class
		extraProps.className = classnames( cleanClassBottom, 'dt-gb-filters-mask__bottom--' + maskImgBottom.replace(/^m-/, '') );
	}

	if (
		(typeof responsiveSelector !== 'undefined' && responsiveSelector != '' )
		&&
		(typeof responsiveCss !== 'undefined' && responsiveCss != '' )
		) {
		// add responsive css to head
		//dt_responsive(responsiveSelector, responsiveCss);
		// add new class
		extraProps.className = classnames( extraProps.className, responsiveSelector );
	}

	return extraProps;
}

addFilter(
	'blocks.getSaveContent.extraProps',
	'dubtempo/applyExtraClass',
	applyExtraClass
);







function applyExtraStyleEle( element, blockType, attributes ) {

	const { responsiveSelector, responsiveCss } = attributes;

	if (!element) {
		return;
	}

	if (
		(blockType.name === 'core/cover')
		&& (typeof responsiveSelector !== 'undefined' && responsiveSelector != '' )
		&& (typeof responsiveCss !== 'undefined' && responsiveCss != '' )
		) {

		element.props.style.backgroundImage = '';

		return (
			<section>
				<style>
					{responsiveCss}
				</style>
				{element}
			</section>
		)
	}

	return element;
}

addFilter(
	'blocks.getSaveElement',
	'dubtempo/applyExtraStyleEle',
	applyExtraStyleEle
);